import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    float: "left",
    marginLeft: -8,
  },
  textContainer: {
    lineHeight: "32px",
  },
  noIconTextContainer: {
    paddingLeft: 24,

    "$placeholder &": {
      paddingLeft: 0,
    },
  },
  placeholder: {},
}));

export default useStyles;
